import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

export default function DashboardTable({ columns, children }) {
  return (
    <TableContainer>
      <Table size="small">
        <TableHead sx={{ whiteSpace: 'nowrap' }}>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={`heading_${column.id}`}
                align={column?.align || 'left'}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  );
}
